import { CbhIcon, Text } from "@clipboard-health/ui-components";
// eslint-disable-next-line no-restricted-imports
import { Box, Chip } from "@mui/material";
import { shiftTypeOptions } from "@src/appV2/redesign/PlacementCandidate/constants";
import { asTimeSlot, type ShiftNameType } from "@src/appV2/redesign/PlacementCandidate/types";
import { getGradientByTimeSlot } from "@src/appV2/redesign/Shift/getGradientByTimeSlot";

interface ShiftTypeChipProps {
  shiftType: ShiftNameType;
}

export function ShiftTypeChip(props: ShiftTypeChipProps) {
  const { shiftType } = props;

  const shiftTypeOption = shiftTypeOptions.find((option) => option.value === shiftType);

  if (!shiftTypeOption) {
    return null;
  }

  return (
    <Chip
      size="small"
      label={
        <Text
          variant="caption"
          color={(theme) => theme.palette.text.primary}
          sx={{ fontWeight: 500 }}
        >
          {shiftTypeOption.label}
        </Text>
      }
      icon={
        <Box display="flex">
          <CbhIcon
            type={shiftTypeOption.icon}
            size="xSmall"
            color={(theme) => theme.palette.text.primary}
          />
        </Box>
      }
      sx={(theme) => ({
        background: getGradientByTimeSlot({
          timeSlot: asTimeSlot(shiftTypeOption.value),
          theme,
        }),
        // shifts the gradient slightly to make the background color lighter
        backgroundSize: "130% 130%",
        height: 18,
        minHeight: 18,
      })}
    />
  );
}
